module.exports = __webpack_public_path__ + "images/feature/new-feature-68a0cf2c5df0b98c4bb7e640677a4062.png";